import React, { Component } from 'react'
import { SOCKET_CLIENT_URL } from '../../../../actions/api'
import Collaborator from './modals/collaborations/Collaborator';
import UpgradeAutoModeration from './modals/Auto Moderation/UpgradeCard';
import CustomPost from "./modals/Custom-Post";
import CustomPostUpgrade from "./modals/Custom-Post-Upgrade";
import DownloadImage from "./modals/Download-image";
import Profanity from "./modals/Profanity-filter";
import { connect } from 'react-redux';
import { getAppsMOreDetails, getCollaborators, getFontVariants, superRefresh } from '../../../../actions/appsMoreAction';
import ManageCollaborator from './modals/collaborations/ManageCollaborator';
import CssUpgrade from './modals/CssUpgrade';
import { HideAppsMore, getInitialRoute } from '../../../../utils';
import Ticker from './modals/ticker/ticker';
import Announcements from './modals/fullScreenAnnouncements/Announcements';
import { TOAST_LOADING } from '../../../../utils';
import HeadFont from './HeadFont';
import { closePricingModal } from '../../../../utils/close_modal';
import { useNavigate } from 'react-router-dom';
import ProfanityUpgrade from './modals/ProfanityUpgrade';
import FeedLimitUpgrade from './modals/FeedLimitUpgrade';
import { useCookies } from 'react-cookie';
import AppsMoreCard from './AppsMoreCard';
import { appsMorePreviewJson } from './appsMorePreviewJson';
import AppsMoreTopBar from './AppsMoreTopBar';
import AiAutoModeration from '../AiAutoModeration';
import AiTrueSense from './modals/AiTrueSense';
import { togglePlanSection_D } from '../../../../actions/showDisplayModalAction';


const AppsMore = (props) => {
    const [cookies, removeCookie] = useCookies(['__ugcupload']);
    const navigate = useNavigate();
    return <AM cookies={cookies} navigate={navigate} removeCookie={removeCookie} {...props} />
}

class AM extends Component {
    constructor(props) {
        super(props)
        this.state = {
            banner: (props.customization) ? true : false,
            customPost: false,
            downloadImage: false,
            profanity: false,
            css: false,
            autoMod: false,
            isCollaborator: false,
            isManageCollaborator: false,
            activeKey: 'background',
            collaboratorData: [],
            cssUpgrade: false,
            CTAUpgrade: false,
            isTicker: false,
            isAnnouncements: false,
            ugcUploader: false,
            UgcUpgradePopup: false,
            FeedLimitExceed: false,
            aiTrueSense: false
        };
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = `${SOCKET_CLIENT_URL}/socket.io/socket.io.js`;
        script.async = true;
        document.body.appendChild(script);
        
        const { cookies, getFontVariants } = this.props;
        getFontVariants()
        getCollaborators().then(res => {
            this.setState({ collaboratorData: res.data.responseData })
        })
     
        if (cookies && cookies.__ugcupload && cookies.__ugcupload === '__ugcupload') {
            this.openUgcUpload()
        }

    }

    onCtaChange = () => {
        this.setState({ banner: false })
    }

    openBanner = (getUpdatedData = true) => {
        this.setState({ banner: false });
        if(getUpdatedData){
         this.props.getAppsMOreDetails()
        }
    };

    openCss = () => {
        this.setState({ css: false })
    };
    openAutoMod = (closeAll) => {
        this.setState({ autoMod: false }, closeAll ? HideAppsMore : null);
    };

    openCustomPost = () => {
        this.setState({ customPost: false })
    };

    openDownloadImage = () => {
        this.setState({ downloadImage: false })
    };

    openProfanity = () => {
        this.setState({ profanity: false })
    };

    openCustomCss = () => {
        if (parseInt(this.props.userDetails.userData.UserRule.customCss) != 0) {
            this.setState({ banner: true, activeKey: 'customCSS' }, HideAppsMore)
        }
        else {
            this.setState({ cssUpgrade: true }, HideAppsMore)
        }

    }

    openTiker = () => {
        this.setState({ isTicker: false })
    };

    superRefresh = () => {
        const wallId = localStorage.getItem('wallId');
        HideAppsMore();
        TOAST_LOADING()
        superRefresh(wallId).then(res => {
            const { responseData } = res.data;
            if (res.data.response_code == 200) {
                const socket = window.io.connect(SOCKET_CLIENT_URL, { transports: ['websocket'], upgrade: false, 
                    reconnection: true,
                    reconnectionDelay: 3000,
                    reconnectionDelayMax: 5000,
                    reconnectionAttempts: 2,  });
                socket.emit('wallsuperrefresh', { 'wallId': wallId, 'sync': responseData[0].id });
            }
        })
    }

    openUgcUpload = () => {
        this.props.navigate(`/wall/snapup/${localStorage.getItem('wallId')}`)
    }

    closeUgcUpgradePopup = () => {
        this.setState({ UgcUpgradePopup: false })
    }

    onCollaborator = () => {
        const { collaboratorData } = this.state;
        this.setState({ isManageCollaborator: collaboratorData.length > 0 ? true : false, isCollaborator: collaboratorData.length > 0 ? false : true }, HideAppsMore)
    }

    getNewCollaborator = () => {
        getCollaborators().then(res => {
            this.setState({ collaboratorData: res.data.responseData })
        })
    }

    upgradeTrueSensePlan = () =>{
        this.setState({ aiTrueSense: false }, ()=> this.props.upgradePlan());
    }

    render() {

        const { autoMod, customPost, downloadImage, profanity, FeedLimitExceed, collaboratorData, cssUpgrade, ugcUploader, UgcUpgradePopup, aiTrueSense } = this.state;
        const { bannerDetail, userDetails, customization, getTags } = this.props;
        const { userData } = userDetails;
        const userRule = userData.UserRule;
        var collaboratorRole = 1;

        return (
            <>
                {bannerDetail?.fonts ? <HeadFont fonts={bannerDetail?.fonts} /> : null}
                {!customization ? <>
                    <div className='more_modal body-bg' id="root_appsMore">
                      <AppsMoreTopBar title='Apps & More' HideAppsMore={() => this.props.closeModal()} />
                        <div className="modal_body__">
                            <div className='container-fluid'>
                                <div className="more_cards_cutom_row row p-3 pt-4">
                                    {collaboratorRole == 1 ? (
                                        <>
                                           {getInitialRoute() != 'socialwalls' ? <AppsMoreCard details={appsMorePreviewJson("Widget Banner")} onClickHandler={() => this.setState({ banner: true, activeKey: 'banner' }, HideAppsMore)} />  : null}
                                           <AppsMoreCard details={appsMorePreviewJson("Ticker")} onClickHandler={() => this.setState({ isTicker: true }, HideAppsMore)} />
                                           <AppsMoreCard details={appsMorePreviewJson("Full Screen Announcements")} onClickHandler={() => this.setState({ isAnnouncements: true }, HideAppsMore)} />
                                           <AppsMoreCard details={appsMorePreviewJson("Custom Post")} onClickHandler={() => this.setState({ customPost: true }, HideAppsMore)} />
                                        </>
                                    ) : null}

                                    {collaboratorRole == 1 ? (
                                        <>
                                           <AppsMoreCard details={appsMorePreviewJson("Profanity Filter")} onClickHandler={() => this.setState({ profanity: true }, HideAppsMore)} />
                                        </>
                                    ) : null}

                                    {(collaboratorRole == 1 && getInitialRoute() != 'socialwalls') ? (
                                        <>
                                           <AppsMoreCard details={appsMorePreviewJson("Auto Moderation")} onClickHandler={() =>{
                                            this.props.closeModal()
                                            localStorage.setItem('auto-pilot', true);
                                            this.props.navigate(`/moderation/index/${bannerDetail.detail.wallId}`)
                                           }} />
                                        </>
                                    ) : null}
                                    {getInitialRoute() == 'socialwalls' && collaboratorRole == 1 ? (
                                        <>
                                           <AppsMoreCard details={appsMorePreviewJson("Analytics")} onClickHandler={() => this.props.navigate(`${![58].includes(this.props?.bannerDetail?.detail?.wall?.User?.UserPlan.planId) ? '/analytic/' : 'analytic/' }${bannerDetail.detail.wallId}`)} />
                                        </>
                                    ) : null}
                                    {
                                        collaboratorRole == 1 ? <>
                                           <AppsMoreCard details={appsMorePreviewJson("Collaboration")} onClickHandler={() => this.onCollaborator()} />
                                        </> : null
                                    }

                                    {
                                        collaboratorRole == 1 ? <>
                                           <AppsMoreCard details={appsMorePreviewJson("Download Images")} onClickHandler={() => this.setState({ downloadImage: true }, HideAppsMore)} />
                                        </>
                                            : null
                                    }
                                           <AppsMoreCard details={appsMorePreviewJson("Super Refresh")} onClickHandler={() => this.superRefresh()} />
                                           {/* <AppsMoreCard details={appsMorePreviewJson("Custom CSS")} onClickHandler={() => this.openCustomCss()} /> */}

                                    {
                                        collaboratorRole == 1 ? <>
                                           <AppsMoreCard details={appsMorePreviewJson("SnapUp")} onClickHandler={() => this.openUgcUpload()} />
                                        </>
                                            : null
                                    }
                                    {
                                        collaboratorRole == 1 &&  getInitialRoute() == 'socialwalls' ? <>
                                           <AppsMoreCard details={appsMorePreviewJson("Interaction")} onClickHandler={() => {
                                            this.props.closeModal()
                                            this.props.navigate(`/wall/personalize/${bannerDetail.detail.wallId}?tab=reactions`)
                                           }} />
                                        </>
                                            : null
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </> : null
                }

                {cssUpgrade == true ? <CssUpgrade onHide={() => this.setState({ cssUpgrade: false })} /> : null}

                {bannerDetail && Object.keys(bannerDetail).length > 0 && bannerDetail.detail && Object.keys(bannerDetail.detail).length > 0 ? <>
                    {customPost ? parseInt(userData.UserRule.customPost) == 0 ? <CustomPostUpgrade showcustomPost={customPost} closecustomPost={this.openCustomPost} /> : <CustomPost showcustomPost={customPost} getData={bannerDetail} closecustomPost={this.openCustomPost} /> : null}

                    {downloadImage ? <DownloadImage showdwonloadImage={downloadImage} getData={bannerDetail} closedwonloadImage={this.openDownloadImage} /> : null}
                
                    {profanity ? userRule.profanityFilter ? <Profanity showProfanity={profanity} getData={bannerDetail} userRule={userRule} closeProfanity={this.openProfanity} /> : <ProfanityUpgrade showProfanity={profanity} closeProfanity={this.openProfanity} /> : null}

                    {autoMod ? parseInt(userData.UserRule.automaticModeration) == 0 ? <UpgradeAutoModeration show={autoMod} openMod={this.openAutoMod} /> : <AiAutoModeration userDetails={userDetails} getTags={getTags} closeModeration={this.openAutoMod} /> : null}

                    {this.state.isCollaborator ? <Collaborator show={true} onHide={() => this.setState({ isCollaborator: false })} collaboratorList={collaboratorData} getNewData={() => this.getNewCollaborator()} /> : null}

                    {this.state.isManageCollaborator ? <ManageCollaborator show={true} onHide={() => this.setState({ isManageCollaborator: false })} isCollaborator={() => this.setState({ isManageCollaborator: false, isCollaborator: true })} userData={collaboratorData} getNewData={() => this.getNewCollaborator()} /> : null}

 
                    {this.state.isTicker ? <Ticker show={true} onHide={() => this.setState({ isTicker: false })} bannerDetails={bannerDetail.detail} fonts={bannerDetail.fonts} /> : null}

                    {this.state.isAnnouncements ? <Announcements details={bannerDetail.detail} show={true} onHide={() => this.setState({ isAnnouncements: false })} /> : null}

                    {FeedLimitExceed ? <FeedLimitUpgrade closeFeedLimitUpgrade={() => this.setState({ FeedLimitExceed: false })} /> : null}

                    {aiTrueSense ? <AiTrueSense closeModal={()=>this.setState({ aiTrueSense: false })} closeAppsMore={this.props.closeModal} trueSenseEnable={userData.user.trueSense} exploreSocialWall={this.upgradeTrueSensePlan} /> : null}

                </> : null}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        bannerDetail: state.appsMore,
        fonts: state.appsMore.fonts,
        userDetails: state.authenticated
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAppsMOreDetails: () => dispatch(getAppsMOreDetails()),
        getFontVariants: () => dispatch(getFontVariants()),
        closeModal: () => closePricingModal(dispatch),
        upgradePlan : () => dispatch(togglePlanSection_D(true))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppsMore)